import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';

const SizeItem = ({summary}) => {
    
    return (
        <>
        <View
            style={{
                marginBottom: "10px"
            }}
        >

        <View
            style={{
                width: "30%",
                flexDirection: "row",
                margin: "auto"
            }}
        >
            <View
                style={{
                    backgroundColor: "#666666",
                    padding: "1px",
                    width: "50%",
                    borderWidth: "1px",
                    borderColor: "#000",
                    borderRightWidth: "0px",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Text
                    style={{
                        fontSize: "7px",
                        color: "#fff",
                        textAlign: "center"
                    }}
                >
                    Size
                </Text>
            </View>
            <View
                style={{
                    backgroundColor: "#666666",
                    padding: "1px",
                    width: "50%",
                    borderWidth: "1px",
                    borderColor: "#000",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Text
                    style={{
                        fontSize: "7px",
                        color: "#fff",
                        textAlign: "center"
                    }}
                >
                    Inspected QTY
                </Text>
            </View>
        </View>
        <View
            style={{
                width: "30%",
                flexDirection: "row",
                margin: "auto"
            }}
        >
            <View
                style={{
                    backgroundColor: "#fff",
                    padding: "1px",
                    width: "50%",
                    borderWidth: "1px",
                    borderColor: "#000",
                    borderTopWidth: "0",
                    borderRightWidth: "0px",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <Text
                    style={{
                        fontSize: "7px",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    {summary.size}
                </Text>
            </View>
            <View
                style={{
                    backgroundColor: "#fff",
                    padding: "1px",
                    width: "50%",
                    borderWidth: "1px",
                    borderColor: "#000",
                    justifyContent: "center",
                    alignItems: "center",
                    borderTopWidth: "0",

                }}
            >
                <Text
                    style={{
                        fontSize: "7px",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    {summary.inspected_measure_check_quantity}
                </Text>
            </View>
        </View>

        <Image 
        src="/images/down-arrow.png"
        style={{
            width: "10px",
            margin: "10px auto 0 auto"
        }}
        />
        </View>

        </>

    )
}

export default SizeItem